import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "hidden", "selected"]

  connect() {
    this.selectedSlugs = this.hiddenTarget.value.split("|").filter(Boolean)
    this.renderSelected()
    this.syncOptions()
  }

  select() {
    const slug = this.selectTarget.value
    if (!slug || this.selectedSlugs.includes(slug)) return

    this.selectedSlugs.push(slug)
    this.sync()
    this.selectTarget.value = ""
    this.submitForm()
  }

  remove(event) {
    const { slug } = event.currentTarget.dataset
    this.selectedSlugs = this.selectedSlugs.filter((value) => value !== slug)
    this.sync()
    this.submitForm()
  }

  sync() {
    this.hiddenTarget.value = this.selectedSlugs.join("|")
    this.syncOptions()
    this.renderSelected()
  }

  syncOptions() {
    Array.from(this.selectTarget.options).forEach((option, index) => {
      if (index === 0) {
        option.hidden = false
        return
      }

      option.hidden = this.selectedSlugs.includes(option.value)
    })
  }

  renderSelected() {
    this.selectedTarget.innerHTML = ""

    this.selectedSlugs.forEach((slug) => {
      const option = Array.from(this.selectTarget.options).find((item) => item.value === slug)
      if (!option) return

      const wrapper = document.createElement("div")
      wrapper.className = "tags has-addons channel-filter__tag-group"

      const tag = document.createElement("span")
      tag.className = "tag is-info is-light"
      tag.textContent = option.text

      const button = document.createElement("button")
      button.type = "button"
      button.className = "tag is-delete channel-filter__remove"
      button.dataset.slug = slug
      button.setAttribute("aria-label", `Remove ${option.text}`)
      button.addEventListener("click", (event) => this.remove(event))

      wrapper.appendChild(tag)
      wrapper.appendChild(button)
      this.selectedTarget.appendChild(wrapper)
    })
  }

  submitForm() {
    const form = this.element.closest('form[data-auto-search-form="true"]')
    if (form) form.requestSubmit()
  }
}
